import * as $ from "jquery";
import { onClick } from "Core/Events";

interface INotificationConfig {
	lifespan?: number;
}


class MiniNotifications {
	root: JQuery<HTMLElement> = $("#miniNoti");
	removeAllButtonSelector = "#miniNotiRemoveAll";
	removeAllButton: JQuery<HTMLButtonElement> = $(this.removeAllButtonSelector);
	
	init() {
		if (this.removeAllButton) {
				onClick(this.removeAllButtonSelector, this.removeAll);
		}
		return this;
	}

	defaults: INotificationConfig = {
		lifespan: 5000,
	}

	removeAll() {
		this.root.find(".noti").each(function() {
			miniNotifications.remove($(this));
		});
	}

	remove(notification: JQuery<HTMLElement>) {
		notification.animate({opacity: 0, marginLeft: -50}, 200, "linear").animate({height: 0}, 100, () => {
			notification.remove();
			miniNotifications.toggleRemoveAllButton();
		});
	}

	toggleRemoveAllButton() {
		if (this.root.find(".noti").length >= 2) {
			this.removeAllButton
				.show()
				.animate({height: 30}, 100)
				.animate({opacity: 1, marginLeft: 0}, 200);
		} else {
			this.removeAllButton
				.animate({opacity: 0, marginLeft: -50}, 200)
				.animate({height: 0}, 100, () => this.removeAllButton.hide());
		}
	}

	add(msg: string, type = "info", config: INotificationConfig = {}, extraClass: string = null) {
		if (!config.lifespan) {
			config.lifespan = this.defaults.lifespan;
		}

		const notifications = $(
			`<span class='noti noti-${type} ${extraClass}'>${msg}<i class='fa fa-times noti-close'></i></span>`,
		);
		notifications
			.css({opacity: 0, marginLeft: -50})
			.animate({opacity: 1, marginLeft: 0}, 200)
			.on('click', '.noti-close', () => this.remove(notifications));

		this.root.append(notifications);
		this.toggleRemoveAllButton();
		setTimeout(() => this.remove(notifications), config.lifespan);
	}
}


const miniNotifications = new MiniNotifications().init();
export { miniNotifications as Notifications };import * as $ from "jquery";
import { onClick } from "Core/Events";

interface INotificationConfig {
	lifespan?: number;
}


class MiniNotifications {
	root: JQuery<HTMLElement> = $("#miniNoti");
	removeAllButtonSelector = "#miniNotiRemoveAll";
	removeAllButton: JQuery<HTMLButtonElement> = $(this.removeAllButtonSelector);
	
	init() {
		if (this.removeAllButton) {
				onClick(this.removeAllButtonSelector, this.removeAll);
		}
		return this;
	}

	defaults: INotificationConfig = {
		lifespan: 5000,
	}

	removeAll() {
		this.root.find(".noti").each(function() {
			miniNotifications.remove($(this));
		});
	}

	remove(notification: JQuery<HTMLElement>) {
		notification.animate({opacity: 0, marginLeft: -50}, 200, "linear").animate({height: 0}, 100, () => {
			notification.remove();
			miniNotifications.toggleRemoveAllButton();
		});
	}

	toggleRemoveAllButton() {
		if (this.root.find(".noti").length >= 2) {
			this.removeAllButton
				.show()
				.animate({height: 30}, 100)
				.animate({opacity: 1, marginLeft: 0}, 200);
		} else {
			this.removeAllButton
				.animate({opacity: 0, marginLeft: -50}, 200)
				.animate({height: 0}, 100, () => this.removeAllButton.hide());
		}
	}

	add(msg: string, type = "info", config: INotificationConfig = {}, extraClass: string = null) {
		if (!config.lifespan) {
			config.lifespan = this.defaults.lifespan;
		}

		const notifications = $(
			`<span class='noti noti-${type} ${extraClass}'>${msg}<i class='fa fa-times noti-close'></i></span>`,
		);
		notifications
			.css({opacity: 0, marginLeft: -50})
			.animate({opacity: 1, marginLeft: 0}, 200)
			.on('click', '.noti-close', () => this.remove(notifications));

		this.root.append(notifications);
		this.toggleRemoveAllButton();
		setTimeout(() => this.remove(notifications), config.lifespan);
	}
}


const miniNotifications = new MiniNotifications().init();
export { miniNotifications as Notifications };